// Bootstrap 3's stepped content widths (720 / 940 / 1140px), which Vue 2's pages sat in; the shared container is fluid below 1200px
export const VUE2_CONTAINER_WIDTHS = 'md:max-w-[752px] lg:max-w-[972px] xl:max-w-[1172px]'
